module.exports = __webpack_public_path__ + "img/gift1.d407bcc1.png";